import {useParams} from 'react-router-dom'
import {PerfilCargoChrome} from '@/components/perfil-cargo-chrome'
import {PerfilAprendeSection} from '@/components/perfil-aprende-section'
import {useOperatorPage} from '@/components/no-access-state'
import {usePerfilCargo} from '@/hooks/empresa/perfil_cargo/use-perfiles-cargo'

/** Sobre un perfil nunca confirmado la pestaña queda vacía con lo que dice el propio componente. */
export function PerfilCargoAprendePage() {
  const {businessId, positionId} = useParams()
  const {business, guard} = useOperatorPage(businessId)
  const perfil = usePerfilCargo(businessId, positionId)
  if (guard) return guard
  return (
    <PerfilCargoChrome
      businessId={businessId!}
      positionId={positionId!}
      cargo={perfil.data?.cargo}
      testId="perfil-cargo-aprende-page">
      {business && <PerfilAprendeSection businessId={businessId!} positionId={positionId!} />}
    </PerfilCargoChrome>
  )
}
